module.exports = {
          srcSet: __webpack_public_path__ + "e81458ce11a862b4b20249e4aadbfb28-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "e81458ce11a862b4b20249e4aadbfb28-1920.png",width: 1920,height: 1080}],
          src: __webpack_public_path__ + "e81458ce11a862b4b20249e4aadbfb28-1920.png",
          toString:function(){return __webpack_public_path__ + "e81458ce11a862b4b20249e4aadbfb28-1920.png"},
          
          width: 1920,
          height: 1080
        }